import { pickCss } from '@/shared/lib/css-utils';
import css from './brief-gaps-dock.module.scss';

const styles = {
  root: pickCss(css, css.root),
  badge: pickCss(css, css.badge),
  labels: pickCss(css, css.labels),
  viewAll: pickCss(css, css.viewAll),
};

type BriefGapsDockProps = {
  count: number;
  /** Short gap labels, e.g. ['Party', 'Diet', 'Pace']. */
  labels: ReadonlyArray<string>;
  onViewAll?: () => void;
};

/**
 * BriefGapsDock — pen component `aXau9`. The compact gap reminder docked in
 * the Step 2 (Day picks) footer. Keeps open gaps visible without taking the
 * consultant out of the picking flow.
 */
export const BriefGapsDock = ({
  count,
  labels,
  onViewAll,
}: BriefGapsDockProps) => {
  if (count <= 0) return null;
  return (
    <div className={styles.root()}>
      <span className={styles.badge()}>
        {count} {count === 1 ? 'warning' : 'warnings'}
      </span>
      <span className={styles.labels()}>{labels.join(' · ')}</span>
      <button className={styles.viewAll()} onClick={onViewAll} type="button">
        View all
      </button>
    </div>
  );
};
